// @flow
import React, { Component } from 'react'
import UploadFile from '../AdEdit/react-upload-file'

type Props = {|
  url: string,
  fileParamName: string,
  file: Object,
  params: Object,
  onSuccess: (string) => void,
  onError: Function,
  onProgress: Function
|}

export default class FileUpload extends Component<Props> {
  uploader: any

  static defaultProps = {
    params: {}
  }

  render() {
    return (
      <UploadFile
        ref={(el) => {
          this.uploader = el
        }}
        options={this.reactUploadOptions()}
        chooseFileButton={<div />}
      />
    )
  }

  componentDidMount() {
    const { file } = this.props

    this.uploader.manuallyUploadFile([file])
  }

  reactUploadOptions() {
    const { params, fileParamName, url, onSuccess, onError, onProgress } = this.props

    return {
      baseUrl: url,
      body: params,
      fileFieldName: fileParamName,
      uploadSuccess: (res: string) => onSuccess && onSuccess(res),
      uploadError: (e: any) => onError && onError(e),
      uploading: (progress: any) => onProgress && onProgress(progress)
    }
  }
}
